import { Theme } from '@mui/material/styles';

export const getMuiInput = (theme: Theme): Record<string, unknown> => ({
  MuiInput: {
    styleOverrides: {
      root: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.black,

        '&:before, &:after': {
          content: 'none',
        },

        '&$error': {
          border: `1px solid ${theme.palette.error.main}`,
          '& input': {
            border: 'none',
          },
        },
        '.success &': {
          border: `1px solid ${theme.palette.success.main}`,
        },
        '&.Mui-error': {
          '& input': {
            border: `1px solid ${theme.palette.error.main}`,
          },
        },
        '& input': {
          border: `1px solid ${theme.palette.grey[400]}`,
          padding: theme.spacing(1.5, 1.25),
          '&:focus': {
            border: `1px solid ${theme.palette.common.black}`,
            boxShadow: 'none',
          },
          '&:-webkit-autofill': {
            transition: 'background-color 5000s ease-in-out 0s',
            fontSize: theme.typography.fontSize,
          },
          '&:autofill': {
            transition: 'background-color 5000s ease-in-out 0s',
            fontSize: theme.typography.fontSize,
          },
          '&::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: '0',
          },
          '&::-webkit-outer-spin-button': {
            WebkitAppearance: 'none',
            margin: '0',
          },
        },
      },
      multiline: {
        '& .MuiInputBase-inputMultiline': {
          border: `1px solid ${theme.palette.grey[400]}`,
          height: '46px',
          minHeight: 'unset',
          padding: theme.spacing(1.5, 1.25),

          '&:focus': {
            border: `1px solid ${theme.palette.common.black}`,
            boxShadow: 'none',
          },
        },
      },
      formControl: {
        'label + &': {
          marginTop: 0,
        },
      },
    },
  },
});
